import { Routes } from '@angular/router';
import { authGuard } from '@guards/auth-guard';
import { noAuthGuard } from '@guards/no-auth-guard';

export const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./home/home.routes').then(r => r.HOME_ROUTES),
        title: 'Biodajo',
        canActivate: [authGuard],
    },
    {
        path: 'inicio-sesion',
        loadComponent: () => import('./auth/login/login').then((c) => c.Login),
        title: 'Inicio Sesión  | BioDajo',
        canActivate: [noAuthGuard],
    },
    {
        path: 'recuperar-contrasena',
        loadComponent: () => import('./auth/restore-password/restore-password.component').then((c) => c.RestorePasswordComponent),
        title: 'Recuperar contraseña | BioDajo',
        canActivate: [noAuthGuard],
    },
    {
        path: 'nueva-contrasena',
        loadComponent: () => import('./auth/new-password/new-password').then((c) => c.NewPassword),
        title: 'Nueva contraseña  | BioDajo',
        canActivate: [noAuthGuard],
    },
    {
        path: 'codigo-verificacion',
        loadComponent: () => import('./auth/verification-code/verification-code.component').then((c) => c.VerificationCodeComponent),
        title: 'Código de verificación | BioDajo',
        canActivate: [noAuthGuard],
    },
    {
        path: 'contrasena-actualizada',
        loadComponent: () => import('./auth/succes-update/succes-update.component').then((c) => c.SuccesUpdateComponent),
        title: 'Contraseña actualizada | BioDajo',
        canActivate: [noAuthGuard],
    },
    {
        path: '**',
        redirectTo: ''
    }
];

